/* istanbul ignore file */
import React from 'react';
import { Dropdown } from 'framework/form';
import { INDUSTRIES } from 'domain/sales/salesService';

const IndustryDropdown = (props: any) => {
  return (
    <Dropdown
      placeholder="Choose Industry"
      options={Object.entries(INDUSTRIES).map(entry => {
        const [value, label] = entry;
        return {
          value,
          label,
        };
      })}
      {...props}
    />
  );
};

export default IndustryDropdown;
